module.exports = __webpack_public_path__ + "img/marivpictureone.ee1dabdf.jpeg";